<template>
  <div class="header">
    <div class="title">
      <div>
        <h2>Plan Summary</h2>
        <p v-if="finalized" style="font-size: 18px">Your Plan Summary is a record of your plan performance and payments. Download a copy for your records.</p>
        <p v-else style="font-size: 18px">Your Plan Summary keeps you informed about your potential award. You will receive email reminders when new forecasts or payments are calculated.</p>
      </div>
      <div
        v-if="message"
        class="message"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import VLcurrency from "@/composables/VLcurrency";
import VLdate from "@/composables/VLdate";

export default {
  name: "PlanHeader",
  components: {},

  props: {
    title: {
      type: String,
      required: true,
    },
    salary: {
      type: Object,
      required: true,
    },
    dates: {
      type: Object,
      required: true,
    },
    isEos: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
    finalized: {
      type: Boolean,
      default: false,
    }
  },

  computed: {},

  mounted() {},

  methods: {
    formatCurrency(value, decimals = 0, currency = 'USD') {
        return VLcurrency.formatCurrency(value, decimals, currency);
    },
    formatDate(d, format = 'YYYY-MM-DD', preset = 'DEFAULT') {
      return VLdate.formatDate(d, format, preset);
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../../../scss/_variables.scss";

.header {
  .title {
    display: flex;
    justify-content: space-between;

    h1 {
      font-size: variables.$text-xl; // ~ 32px
      line-height: 1.0625;
      font-weight: 700;
      margin-bottom: 0;
    }
    h2 {
      text-transform: capitalize;
      margin-bottom: 0;
    }

    .message {
      min-width: 400px;
      width: 50%;

      border: 1px solid var(--charcoal-tint-20);
      border-radius: 8px;
      padding: 0.5rem 1rem;
    }

    .info-grid {
      font-size: variables.$text-base;
      line-height: 1.6875;
    }
  }

  .info-wrap {
    display: flex;
    justify-content: space-between;

    font-size: variables.$text-base;
    line-height: 1.6875;
  }

  .info-grid {
    display: grid;
    grid-template-columns: min-content min-content;
    grid-auto-rows: min-content;

    grid-column-gap: 0.5rem;

    span {
      white-space: nowrap;
      text-align: right;

      // info title
      &:nth-child(odd) {
        font-family: variables.$font-primary;
      }

      // info content
      &:nth-child(even) {}
    }
  }

  .info-salary {
    margin-top: auto;

    text-transform: capitalize;
  }
}

</style>